import React, { useState } from 'react'
import { HiEye, HiEyeOff } from 'react-icons/hi'
import { useDispatch } from 'react-redux'
import { login } from '../../redux/slices/AuthSlice'
import { sessionStorageSetItem } from '../../utils/globalFunction'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
// import { toast } from 'react-toastify'

function Login() {
  const [showPassword, setShowPassword] = useState(false)
  const [formLoginData, setFormLoginData] = useState({ userName: '', password: '' })
  const [errorLoginData, setErrorLoginData] = useState({ userName: '', password: '' })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [globalError, setGlobalError] = useState('')

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormLoginData((prev) => ({ ...prev, [name]: value }))
    setErrorLoginData((prev) => ({ ...prev, [name]: '' }))
    setGlobalError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Client-side validation
    let hasError = false
    const newErrors = { userName: '', password: '' }

    if (!formLoginData.userName.trim()) {
      newErrors.userName = 'Username is required'
      hasError = true
    }

    if (!formLoginData.password.trim()) {
      newErrors.password = 'Password is required'
      hasError = true
    }

    if (hasError) {
      setErrorLoginData(newErrors)
      return
    }

    setIsSubmitting(true)
    try {
      const res = await dispatch(login(formLoginData)).unwrap()
      if (res.data) {
        toast.success(res?.message)
        sessionStorageSetItem(res.data)
        navigate('/app/dashboard')
      }
      if (!res?.data) {
        toast.error(res?.message)
      }
    } catch (err) {
      setGlobalError(err?.message || 'Login failed. Please try again.')
      // toast.error(err)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className='bg-gray-100 h-screen flex justify-center items-center px-4'>
      <div className='w-full max-w-md bg-white rounded-2xl shadow-lg p-8 space-y-6'>
        <div className='flex flex-col items-center space-y-2'>
          <img src='/icons8-system-administrator-female-100.png' alt='Admin' className='w-20 h-20' />
          <img src='/first-screen-logo.svg' alt='Logo' className='w-32' />
        </div>

        <h2 className='text-2xl font-bold text-center text-gray-800'>Admin Login</h2>

        {globalError && <div className='text-red-600 text-sm text-center'>{globalError}</div>}

        <form onSubmit={handleSubmit} className='space-y-5'>
          <div>
            <label htmlFor='userName' className='block text-sm font-medium text-gray-700 mb-1'>
              Username
            </label>
            <input
              type='text'
              name='userName'
              id='userName'
              value={formLoginData.userName}
              onChange={handleInputChange}
              className={`w-full p-3 rounded-lg border ${errorLoginData.userName ? 'border-red-500' : 'border-gray-300'
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
              placeholder='Enter username'
            />
            {errorLoginData.userName && (
              <p className='text-red-500 text-sm mt-1'>{errorLoginData.userName}</p>
            )}
          </div>

          <div className='relative'>
            <label htmlFor='password' className='block text-sm font-medium text-gray-700 mb-1'>
              Password
            </label>
            <input
              type={showPassword ? 'text' : 'password'}
              name='password'
              id='password'
              value={formLoginData.password}
              onChange={handleInputChange}
              placeholder='••••••••'
              className={`w-full p-3 rounded-lg border pr-10 ${errorLoginData.password ? 'border-red-500' : 'border-gray-300'
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
            />
            <button
              type='button'
              onClick={() => setShowPassword((prev) => !prev)}
              className='absolute right-3 top-[38px] text-gray-500 hover:text-gray-700'
            >
              {showPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
            </button>
            {errorLoginData.password && (
              <p className='text-red-500 text-sm mt-1'>{errorLoginData.password}</p>
            )}
          </div>

          <button
            type='submit'
            disabled={isSubmitting}
            className={`w-full text-white font-medium rounded-lg text-sm px-5 py-3 transition-colors ${isSubmitting ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
              }`}
          >
            {isSubmitting ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </section>
  )
}

export default Login